import * as React from "react";

const IconErrorLight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={96}
    height={96}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M56.447 36H32.02l.506-3h24.427l-.506 3Zm-.994 6H31.026l-.506 3h24.427l.506-3Zm-6.795 39.067L52.453 58.5H28.026L22.94 88.748A1.5 1.5 0 0 1 21.46 90H11.046a1.5 1.5 0 0 1-1.481-1.748l12.986-77.25A6 6 0 0 1 28.468 6h38.79a6 6 0 0 1 5.918 6.994L66.79 51a6.658 6.658 0 0 1 9.465 2.205L86.59 71.119 76.405 10.5A8.978 8.978 0 0 0 67.528 3h-39.06a8.977 8.977 0 0 0-8.876 7.5L6.606 87.75a4.5 4.5 0 0 0 4.44 5.25H21.46a4.5 4.5 0 0 0 4.44-3.75l4.665-27.75H40.69l4.372 26.025c.138-.383.308-.753.51-1.106l3.086-5.352Z"
    />
    <path
      fill="url(#b)"
      d="M92.55 88.08 73.38 54.851a3.325 3.325 0 0 0-5.76 0l-19.17 33.23a3.322 3.322 0 0 0 2.88 4.983h38.34a3.322 3.322 0 0 0 2.88-4.984ZM72.677 64.523l-.405 15.75H68.78l-.44-15.75h4.336Zm-.15 23.163a2.977 2.977 0 1 1 .795-2.017 2.744 2.744 0 0 1-.803 2.017h.008Zm-19.223-71.67c.192-1.815-.956-4.106-5.062-4.106H40.31l-3.63 15h4.125l1.32-5.535h2.29l3.537 5.543h4.586L48.413 20.8c3.552-1.248 4.602-2.775 4.89-4.785Zm-4.586.29c-.191 1.72-1.339 2.1-3.345 2.1h-3.056l1.241-4.205h3.056c1.722 0 2.295.957 2.104 2.104Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={6.543}
        x2={58.525}
        y1={3}
        y2={107.024}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.272} stopColor="#412A5C" />
        <stop offset={0.658} stopColor="#34263B" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={51.253}
        x2={88.92}
        y1={73.875}
        y2={52.046}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.35} stopColor="#FF495F" />
        <stop offset={0.85} stopColor="#DB91FA" />
      </linearGradient>
    </defs>
  </svg>
);
export default IconErrorLight;
